import type { CartItem, CustomerDetails, OrderValidationErrors } from "../types";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateOrder(customer: CustomerDetails, cart: CartItem[]) {
  const errors: OrderValidationErrors = {};
  const email = customer.email.trim();
  const phone = customer.phone.trim();

  if (cart.length === 0) {
    errors.cart = "Lägg till minst ett plagg i beställningen.";
  }
  if (!customer.name.trim()) {
    errors.name = "Fyll i ditt namn.";
  }
  if (!email && !phone) {
    errors.contact = "Fyll i antingen e-post eller telefonnummer.";
  } else {
    if (email && !emailPattern.test(email)) {
      errors.email = "Fyll i en giltig e-postadress.";
    }
    if (phone && phone.replace(/\D/g, "").length < 7) {
      errors.phone = "Fyll i ett giltigt telefonnummer.";
    }
  }

  return errors;
}
